import React from "react";
import { AppState } from "../../enums/AppState";
import personIcon from "assets/ui-img/personWhiteCircleBg.png";

import {
  CustomerInfo,
  Header,
  PaginationHelper,
  TitleBar,
  // Footer,
} from "webapp/components";
import "./ConfirmCustomer.scss";

import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useState } from "react";
import { apiCancelCallPending } from "utils/API/TrxNowAPI";
import TVLAccidentQuestion from "webapp/components/Partner/TVL/TVLAccidentModal/TVLAccidentModal";
import { ARIAccidentModal } from "webapp/components/Partner/ARI/ARIAccidentModal";
import { devLog } from "utils/devLog";

/**
 * @param {
 * currState - imports the current form information into the view if it exists
 * onUserNext - imports the callback function which will update the main state
 *  with new a new first name, last name, and number
 * onUserBack - imports the functionality to regress the webapp by one state
 *  to the locate user in this case
 * } props
 * @returns {
 * data - firstName, lastName, callBackNumber into callbackfunction and set submit stage
 * }
 */
export default function ConfirmCustomer(props) {
  const { t } = useTranslation();

  const [context] = useState(props.context);

  const [enablePolicyNumber, setEnablePolicyNumber] = useState(false);

  const customerInfoObj = {
    firstName: props.currState.FirstName,
    lastName: props.currState.LastName,
    number: props.currState.Number,
    policyNumber: props.currState.PolicyNumber,
    companyName: props?.currState?.MemberLookup?.companyName,
    driverNumber: props?.currState?.MemberLookup?.driverNumber,
    country: props?.currState?.DisablementCountry,
  };

  //object that is passed down into the titlebar
  const ConfirmCustomerObj = {
    img:
      props.currState.partner === "TVL" || props.currState.partner === "PBFL"
        ? props.currState.localGroupLogo
        : personIcon,
    partner: props.currState.partner,
    fragment: (
      <React.Fragment>
        <p>{t("description.ConfirmCustomerTitleBar1")}</p>
      </React.Fragment>
    ),
  };

  useEffect(() => {
    setEnablePolicyNumber(props.currState?.partner === "TVL");
  }, [props]);

  const onUserBack = (e) => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack(e);
    }
  };

  const onUserNext = (data) => {
    devLog("context", context);
    if (typeof props.onUserNext === "function") {
      props.onUserNext(data);
    }
  };

  const onUserCancel = (data) => {
    devLog("context", context);
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel(data);
    }
  };

  return (
    <div className="CustCollectPage">
      <Header
        currState={props.currState}
        onUserBack={onUserBack}
        information={t("description.ConfirmCustomerHeader1")}
      />
      <TitleBar data={ConfirmCustomerObj} />
      <PaginationHelper context={props.context} />
      <CustomerInfo
        currState={props.currState}
        customerInfoObj={customerInfoObj}
        enablePolicyNumber={enablePolicyNumber}
        onUserNext={onUserNext}
        onUserCancel={onUserCancel}
      />
      {props.currState.partner === "TVL" && props.currState.TVLAccidentQuationAsked == null ? (
        <TVLAccidentQuestion
          logo={props.currState.localGroupLogo}
          state={props.currState}
          onYes={() => {
            props.context.setState(
              {
                TVLAccidentQuationAsked: true,
              },
              () => {
                apiCancelCallPending(props.context.state, (response) => {
                  devLog("confirmCancel response:", response);

                  // call was cancelled so take them to final cancel screen
                  props.context.setState({
                    webAppState: AppState.AccidentConfirmed,
                  });
                });
              },
            );
          }}
          onNo={() => {
            props.context.setState({
              TVLAccidentQuationAsked: true,
            });
          }}
        />
      ) : (
        <></>
      )}

      {(props.currState.partner === "ARIU" || props.currState.partner === "ARIC") &&
      props.currState.ARIAccidentQuationAsked == null ? (
        <ARIAccidentModal
          logo={props.currState.localGroupLogo}
          state={props.currState}
          onYes={() => {
            props.context.setState(
              {
                ARIAccidentQuationAsked: true,
              },
              () => {
                apiCancelCallPending(props.context.state, (response) => {
                  devLog("confirmCancel response:", response);

                  // call was cancelled so take them to final cancel screen
                  props.context.setState({
                    webAppState: AppState.AccidentConfirmed,
                  });
                });
              },
            );
          }}
          onNo={() => {
            props.context.setState({
              ARIAccidentQuationAsked: false,
            });
          }}
        />
      ) : (
        <></>
      )}
    </div>
  );
}
